export default __webpack_public_path__ + "static/media/image-11.dfd5cdf4.png";